import React from 'react';
import { motion } from 'framer-motion';
import { useForm, ValidationError } from '@formspree/react';
import { useLanguage } from '../contexts/LanguageContext';
export function FunctionalSpiceGrid() {
  const {
    t
  } = useLanguage();
  const [state, handleSubmit] = useForm('mkoaalae');
  const spices = [{
    name: t('functional.focus.name'),
    subtitle: t('functional.focus.subtitle'),
    image: 'https://cdn.magicpatterns.com/uploads/myG37TDhLgDXgLCTX3LLJX/BFN_Cinnamon_Swirl_Use_Case.jpg',
    alt: 'Focus blend sprinkled over a cinnamon swirl',
    spice: t('functional.focus.spice'),
    benefits: t('functional.focus.benefits'),
    description: t('functional.focus.description')
  }, {
    name: t('functional.energy.name'),
    subtitle: t('functional.energy.subtitle'),
    image: 'https://cdn.magicpatterns.com/uploads/mKKRAh1WKkjVfGpaJsLDbB/IMG_7279.jpg',
    alt: 'NeuroSpice Energy tin with a line of paprika and cordyceps blend',
    spice: t('functional.energy.spice'),
    benefits: t('functional.energy.benefits'),
    description: t('functional.energy.description')
  }, {
    name: t('functional.calm.name'),
    subtitle: t('functional.calm.subtitle'),
    image: 'https://cdn.magicpatterns.com/uploads/15XekjX4aBTRDddPQeRC6c/Popcorn_x_REST_blend_.png',
    alt: 'Hand sprinkling NeuroSpice Rest salt and reishi over popcorn',
    spice: t('functional.calm.spice'),
    benefits: t('functional.calm.benefits'),
    description: t('functional.calm.description')
  }];
  return <section className="w-full py-32 px-6 bg-white" data-id="element-201" data-mp="2g5r0q4c0w2os">
      <div className="max-w-6xl mx-auto" data-id="element-202" data-mp="2g465echvwfpv">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-203" data-mp="2b7692tau6rby">
          <div className="inline-block px-4 py-1 border border-black text-xs font-mono tracking-wider uppercase mb-6" data-id="element-204" data-mp="119fyxsebj3zt">
            {t('functional.badge')}
          </div>
          <h2 className="text-6xl md:text-8xl font-black text-black mb-6 uppercase tracking-tighter leading-none" data-id="element-205" data-mp="s900wygcgp2c">
            {t('functional.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-4" data-id="element-206" data-mp="iif3hecepql0">
            {t('functional.subtitle')}
          </p>
          <p className="text-sm text-gray-700 max-w-xl mx-auto" data-id="element-207" data-mp="n9ez8g9si2lx">
            {t('functional.pending')}{' '}
            <a href="https://www.berlinfoodweek.de/festival/house-of-food/" target="_blank" rel="noopener noreferrer" className="font-bold text-black underline underline-offset-4 hover:text-gray-600 transition-colors duration-150" data-id="element-208" data-mp="8lae75n9lezz">
              {t('functional.presale.link')}
            </a>
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-209" data-mp="3h1gj43lye288">
          {spices.map((spice, index) => <motion.div key={spice.name} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="border-2 border-black bg-white flex flex-col overflow-hidden" data-id="element-210" data-mp="3c4gkgdrfo1r5" data-mpi={index}>
              <div className="aspect-[4/3] overflow-hidden border-b-2 border-black bg-gray-100" data-id="element-211" data-mp="dnm2goo5l5jd">
                <img src={spice.image} alt={spice.alt} className="w-full h-full object-cover" data-id="element-212" data-mp="8oj9i2lg6prr" />
              </div>
              <div className="p-8 flex flex-col flex-1" data-id="element-213" data-mp="hopgr6qjytih">
              <h3 className="text-3xl font-black mb-1 uppercase tracking-tight" data-id="element-214" data-mp="2c3uzzmnyys0k">
                {spice.name}
              </h3>
              <p className="text-xs text-gray-500 mb-4 uppercase tracking-widest" data-id="element-215" data-mp="2h14uvhu4nvvs">
                {spice.subtitle}
              </p>
              <p className="text-sm text-gray-700 mb-3 uppercase tracking-wider font-medium" data-id="element-216" data-mp="2lvik12i756s0">
                {spice.spice}
              </p>
              <p className="text-xs text-gray-500 mb-4 font-mono" data-id="element-217" data-mp="1t58yw7sgd0wn">
                {spice.benefits}
              </p>
              <p className="text-sm leading-relaxed text-gray-800" data-id="element-218" data-mp="1y4d4ypk2yiir">
                {spice.description}
              </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} id="waitlist" className="scroll-mt-28 border-2 border-black p-8 md:p-12 bg-white" data-id="element-219" data-mp="275b8z7uiqq1c">
          <div className="text-center mb-8" data-id="element-220" data-mp="3nqc4k7hw1ii9">
            <h3 className="text-3xl font-black text-black mb-4 uppercase tracking-tight" data-id="element-221" data-mp="3iwr50b0ncggy">
              {t('functional.waitlist.title')}
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto mb-2" data-id="element-222" data-mp="3etus90xsfekx">
              {t('functional.waitlist.description')}
            </p>
            <p className="text-sm text-gray-500 italic" data-id="element-223" data-mp="34x89qisxozm2">
              {t('functional.waitlist.note')}
            </p>
          </div>

          {state.succeeded ? <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-center text-xl font-black text-black uppercase tracking-wider" role="status" data-id="element-224" data-mp="300hufxoye81p">
              {t('functional.waitlist.success')}
            </motion.p> : <form onSubmit={handleSubmit} className="max-w-md mx-auto flex flex-col sm:flex-row gap-3" data-id="element-225" data-mp="2sfp40bmyvu9t">
              <div className="flex-1 flex flex-col gap-2" data-id="element-226" data-mp="2epbsy0es3zg9">
                <input id="email" type="email" name="email" placeholder={t('functional.waitlist.placeholder')} required className="w-full px-6 py-3 bg-black/5 border-2 border-black text-black placeholder-gray-500 focus:outline-none transition-colors font-mono" data-id="element-227" data-mp="2iokonatdq7eg" />
                <ValidationError prefix="Email" field="email" errors={state.errors} className="text-xs text-red-600 font-mono" data-id="element-228" data-mp="32d3abif6f2oe" />
              </div>
              <button type="submit" disabled={state.submitting} className="px-8 py-3 bg-black text-white font-black hover:bg-gray-800 transition-all duration-200 uppercase tracking-wider text-sm disabled:opacity-50 disabled:cursor-not-allowed self-start" data-id="element-229" data-mp="1qyxzq6kgjuk3">
                {state.submitting ? '...' : t('functional.waitlist.cta')}
              </button>
            </form>}
        </motion.div>
      </div>
    </section>;
}